'use client'

import { useEffect } from 'react'
import { analytics } from '@/tools/analytics'
import { useErrorHandling } from '@/tools/o11y/client'
import { useUserData } from '@/user/useUserData'

export const AuthStateGuard = () => {
  const { execWithErrorTracking } = useErrorHandling()
  const { userData } = useUserData()

  // Analytics
  useEffect(() => {
    execWithErrorTracking(async () => {
      analytics.setGlobalAttribute('userId', userData?.id || null)
    })
  }, [execWithErrorTracking, userData])

  return <></>
}
